/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const OffersIcon = ({ width = 24, height = 24, hidden = false, title = 'Offers' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="14" cy="18" r="2" />
    <path
      d="m31.086 5.54.132 3.66a2.984 2.984 0 0 0 1.524 2.496l3.2 1.8-3.66.132a2.986 2.986 0 0 0-2.498 1.524l-1.8 3.2-.132-3.66a3 3 0 0 0-1.524-2.498l-3.2-1.79 3.672-.142a2.984 2.984 0 0 0 2.496-1.524l1.79-3.198Z"
    />
    <path
      d="m31.526 16.124-3.108 4.034a1 1 0 0 1-1.78-.454l-.78-4.95a1 1 0 0 0-.504-.826L21.02 11.01a.958.958 0 0 1-.412-.924l1.244-2.22a2.32 2.32 0 0 1 1.938-1.184l2.844-.102-2.482-1.38a2.316 2.316 0 0 1-1.184-1.938L22.864.4l-1.4 2.482a2.318 2.318 0 0 1-1.938 1.184l-2.842.102 2.482 1.4a2.316 2.316 0 0 1 1.182 1.938L20.45 10H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V15.724a.936.936 0 0 0-.474.4ZM4 14h14v11.332l-3.48-3.2a1 1 0 0 0-1.296-.046l-2.332 1.842-2.75-3.4a1 1 0 0 0-1.456-.104L4 22.926V14Zm24 16H4v-2h24v2Zm0-4h-8v-2h8v2Z"
    />
  </svg>`;
};
